function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: #46494c;\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: ",
        ";\n  text-transform: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { fontSize } from 'styled-system';
/**
 * @typedef {import('styled-system').FontSizeProps} FontSizeProps
 */ var StyledHeader = /** @type {import('styled-components').ThemeStyledFunction<'h2', FontSizeProps>} */ styled.h2(_templateObject(), function(props) {
    return props.mb ? props.mb : '21px';
}, function(props) {
    return props.lowercase ? 'none' : 'uppercase';
}, fontSize);
export default StyledHeader;
